import { atom } from "recoil";

interface PartnerQuoteCalendarModal {
  open: boolean;
  startDate?: Date;
  endDate?: Date;
}

export const isOpenQuoteAndOrderCalendarModal = atom<PartnerQuoteCalendarModal>(
  {
    key: "isOpenQuoteAndOrderCalendarModal",
    default: {
      open: false,
      startDate: undefined,
      endDate: undefined,
    },
  }
);
